import { types, flow, Instance } from 'mobx-state-tree';
import { Setting } from './types';
import { AxiosResponse } from 'axios';
import axios from 'server';

const { model, boolean } = types;

export const EndUserConfigStore = model('EndUserConfigStore', {
  registartionPermited: boolean,
  recoveryPermited: boolean,
})
  .actions((self) => ({
    normalizePermissions: ({ data: { data } }: AxiosResponse<{ data: Setting[] }>): void => {
      const recoverySetting = data.find(({ key }) => key === 'endUsersRecoverUserIdPassword');
      const registerSetting = data.find(({ key }) => key === 'endUsersRegisterAccount');
      self.registartionPermited = registerSetting?.value !== '0' ? true : false;
      self.recoveryPermited = recoverySetting?.value !== '0' ? true : false;
    },
  }))
  .actions((self) => ({
    getPermissions: flow(function* () {
      const result = yield axios
        .get('admin/no-auth-user-settings-get?sectionKey=general')
        .then(self.normalizePermissions)
        .catch((error) => {
          throw new Error(error);
        });
      return result;
    }),
  }));

export type IEndUserConfigStore = Instance<typeof EndUserConfigStore>;
